import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {Resource} from 'app/constants/resource';
import {Budget, IBudget} from 'app/blocks/model/budget.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {BudgetService} from 'app/blocks/service/api/budget.service';

@Injectable({
    providedIn: 'root'
})
export class BudgetResource extends AbstractEntityResource<IBudget> {
    constructor(budgetService: BudgetService, router: Router) {
        super(
            Resource.BUDGETS,
            budgetService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.BUDGETS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.BUDGETS),
            (entity?) => new Budget(entity),
            (entity) => entity.id,
            'share'
        );
    }
}
